module.exports = {"tableConfig":{"columns":[{"header":"DATA","mobileWidth":"0%","width":"25%","showInMobile":false},{"header":"HORA","mobileWidth":"0%","width":"20%","showInMobile":false},{"header":"ARQUIVO","mobileWidth":"25%","width":"20%","showInMobile":true},{"header":"SEQUENCIAL","mobileWidth":"30%","width":"20%","showInMobile":true},{"header":"STATUS","mobileWidth":"45%","width":"20%","showInMobile":true}]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/RequestFile/table/data.json
// module id = 2255
// module chunks = 0